/**
 * Projects-section seeds (starter-registry plan R3) — native RDM table
 * replacements for the legacy Kanban / Retrospective clones (the
 * legacy-replacement protocol: legacy cards carry `replacedBy` and drop
 * once the native seed's first-edit rate beats them).
 */

import type { SeedProvider } from '../SeedRegistry';

const KANBAN_BASIC_RDM = `---
type: table
title: "Kanban Board"
---
table kanban "Kanban Board" { layout: stack }
card td_1 "Draft Q3 launch brief" { cell: "To Do" }
card td_2 "Collect customer quotes" { cell: "To Do" }
card ip_1 "Pricing page redesign" { cell: "In Progress" }
card ip_2 "Onboarding email sequence" { cell: "In Progress" }
card dn_1 "Competitor teardown" { cell: "Done" }
`;

const RETRO_BASIC_RDM = `---
type: table
title: "Retrospective"
---
table retro "Sprint Retrospective" { columns: ["Went well", "To improve", "Action items"], layout: stack }
sticky ww_1 "Shipped the release on time" { cell: "Went well" }
sticky ww_2 "Pairing cut review time in half" { cell: "Went well" }
sticky ti_1 "Standups ran long" { cell: "To improve" }
sticky ti_2 "Flaky tests slowed CI" { cell: "To improve" }
sticky ai_1 "Timebox standup to 10 min" { cell: "Action items" }
sticky ai_2 "Quarantine flaky tests this week" { cell: "Action items" }
`;

export const kanbanBasicSeed: SeedProvider = {
  id: 'kanban-basic',
  type: 'flowchart',
  label: 'Kanban board',
  provide: () => ({ format: 'rdm', rdm: KANBAN_BASIC_RDM }),
};

export const retroBasicSeed: SeedProvider = {
  id: 'retro-basic',
  type: 'flowchart',
  label: 'Sprint retrospective',
  provide: () => ({ format: 'rdm', rdm: RETRO_BASIC_RDM }),
};
